<template>
    <v-card v-if="fieldId">
        <v-card-title>
            <h2 class="OptionsGroup__title">
                Field Data
            </h2>
        </v-card-title>
        <v-card-subtitle>Data for the field that this population is attached to.</v-card-subtitle>
        <v-card-text>
            <h3 class="PopulationPanels__subhead">
                Field:
            </h3>
            <p>
                {{ stepName }}\{{ sectionName }}\{{ cardName }}\<router-link :to="'/field/edit/' + fieldId">
                    {{ fieldName }}
                </router-link>
            </p>
            <h3 class="PopulationPanels__subhead">
                Populations:
            </h3>
            <PopulationPanels
                :field-id="fieldId"
                :field-type="fieldType"
                :professions="professions"
            />
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import PopulationPanels from '@/views/Admin/Config/Population/PopulationPanels';

export default {
    components: { PopulationPanels },
    computed: {
        ...mapState('populationEditor', [
            'stepId',
            'stepName',
            'sectionId',
            'sectionName',
            'fieldId',
            'fieldName',
            'fieldType',
            'fieldOptions',
            'cardId',
            'cardName',
            'professions',
        ])
    },
};
</script>
